'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'suitcase';
var width = 512;
var height = 512;
var aliases = [129523];
var unicode = 'f0f2';
var svgPathData = ['M16 160l0 256c0 26.5 21.5 48 48 48l24 0 0-352-24 0c-26.5 0-48 21.5-48 48zm88-48l0 352 304 0 0-352-32 0-240 0-32 0zm320 0l0 352 24 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-24 0z', 'M144 40l0 56 224 0 0-56c0-13.3-10.7-24-24-24L168 16c-13.3 0-24 10.7-24 24zM128 96l0-56c0-22.1 17.9-40 40-40L344 0c22.1 0 40 17.9 40 40l0 56 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm248 16l-240 0-32 0 0 352 304 0 0-352-32 0zM88 112l-24 0c-26.5 0-48 21.5-48 48l0 256c0 26.5 21.5 48 48 48l24 0 0-352zM424 464l24 0c26.5 0 48-21.5 48-48l0-256c0-26.5-21.5-48-48-48l-24 0 0 352z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSuitcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;